import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda/src/index';
import {observer} from 'mobx-react';
import Result from './components/Result';
import Scroller from './Scroller';
import Notifier from 'components/notifier/Notifier';

const ResultsGroup = ({total, remaining, loading, results, searchQuery, isTablet, translations}) => (
  <>
    {
      (total > 0 && remaining !== 0) &&
        <Scroller>
          {
            R.take(100, results).map((result) => (
              <Result
                key={result.groupId}
                result={result}
                searchQuery={searchQuery}
                loading={loading}
                isTablet={isTablet}
                translations={translations}
              />
            ))
          }
        </Scroller>
    }
    {
      ((total === 0 || remaining === 0) && !loading) &&
        <Notifier status="warning"><strong>{translations.errNoResults}</strong></Notifier>
    }
  </>
);

ResultsGroup.propTypes = {
  total: PropTypes.number,
  remaining: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  results: PropTypes.array.isRequired,
  searchQuery: PropTypes.object.isRequired,
  isTablet: PropTypes.bool.isRequired,
  translations: PropTypes.object.isRequired
};

export default observer(ResultsGroup);
